import React from "react";
import { toast } from "react-toastify";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Stack, Typography } from "@mui/material";
import { Menu } from "components/popups";
import { copyToClipboard } from "utils";

import { useEmailsContext } from "../context/Email-context";

interface Props {}

export const PopoverHeader: React.FC<Props> = () => {
  const hostname = window.location.hostname;
  const { setIsFullScreen } = useEmailsContext();

  const onClickCopy = () => {
    try {
      copyToClipboard(`inbox@${hostname}`);
      toast("Email address was copied to clipboard");
    } catch (_error) {
      console.log("Something went wrong, impossible to copy deal email");
    }
  };

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography sx={{ color: "#071F35", fontSize: "18px", fontWeight: "400" }}>Inbox</Typography>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap="10px">
        <Typography
          onClick={() => setIsFullScreen(true)}
          sx={{ color: "#26A6AE", fontSize: "12px", fontWeight: "400", cursor: "pointer" }}
        >
          Full screen
        </Typography>
        <Menu
          options={[
            {
              title: `inbox@${hostname}`,
              icon: <ContentCopyIcon />,
              onClick: onClickCopy
            }
          ]}
        />
      </Stack>
    </Stack>
  );
};
